import React from 'react'
import Head from 'next/head'
import { useRouter } from 'next/router'

import {
  HeaderBar,
  HeaderBarLeftAction,
  HeaderBarTitle,
} from '@wartek-id/header-bar'
import { historyUtils } from '@wartek-id/fe-toolbox'

import { useAuth } from 'utils/auth'
import AndroidHandler from 'utils/androidHandler'
import { useLocalStorage } from 'utils/hooks/useLocalStorage'
import { REFERRER_KEY } from 'utils/hooks/useRouterHistory'

import ArrowLeftIcon from 'assets/icons/arrow-left.svg'

interface BuktiKaryaPageHeaderProps {
  title: string
  withRightActionPopoverMenu?: boolean
  forceNavigateBack?: boolean
  onBackClick?: () => void
  variant?: 'default' | 'inherit' | 'large' | 'transparent' | 'semi-transparent'
}

/**
 * @deprecated Bukti Karya is no longer served from guru-frontend and this is no longer maintained
 */
const BuktiKaryaPageHeader = ({
  title,
  forceNavigateBack = false,
  onBackClick = null,
  variant = 'default',
}: BuktiKaryaPageHeaderProps) => {
  const { session } = useAuth()
  const router = useRouter()
  const [, , , getReferrerValue] = useLocalStorage(REFERRER_KEY, null)
  const referrer = getReferrerValue()

  const androidHandler = AndroidHandler()

  const handleForceBackNavigation = () => {
    if (androidHandler.enabled) historyUtils.backToApp(router.back)
    else router.back()
  }

  const handleDefaultFilteredBackNavigation = () => {
    if (!session || referrer !== '') {
      router.back()
    } else {
      router.push('/home')
    }
  }

  const handleAndroidFilteredBackNavigation = () => {
    historyUtils.backToApp(router.back)
  }

  const handleBackNavigationClick = () => {
    if (onBackClick) return onBackClick()
    if (forceNavigateBack) return handleForceBackNavigation()
    if (androidHandler.enabled) return handleAndroidFilteredBackNavigation()

    return handleDefaultFilteredBackNavigation()
  }

  return (
    <>
      <Head>
        <title>{title}</title>
      </Head>
      <HeaderBar variant={variant}>
        <HeaderBarLeftAction onClick={() => handleBackNavigationClick()}>
          <ArrowLeftIcon
            width={24}
            height={24}
            className="fill-current text-icon-default"
          />
        </HeaderBarLeftAction>
        <HeaderBarTitle className="capitalize">{title}</HeaderBarTitle>
      </HeaderBar>
    </>
  )
}

export default BuktiKaryaPageHeader
